<template>
  <div>
    <!-- toolbar container -->
    <div>
      <!-- PC TOOLBAR -->
      <div v-if="!$vuetify.breakpoint.xs" class="pl-4 pr-4 pt-4">

        <v-layout align-center>
          <div class="display-1 mt-4">
            Inventory
          </div>
        </v-layout>

      </div>

      <!-- MOBILE toolbar -->
      <div v-if="$vuetify.breakpoint.xs" class="toolbar-mobile">
        <v-layout align-center>
          <v-btn icon @click="drawer = !drawer">
            <v-icon>menu</v-icon>
          </v-btn>
          <v-flex class="text-ellipsed text-sans font-weight-bold">
            Inventory
          </v-flex>
        </v-layout>
      </div>

    </div>
    <!-- end toolbar container -->

    <v-layout wrap>
      <v-flex class="xs12 md3">
        <v-card class="ml-2" style="height: 100%;">
          <v-layout class="pa-4 title border-b--thin">
            Labels
          </v-layout>
          <category-card :selected.sync="filters.categories" :widgetMode="0" :editable="true"></category-card>
        </v-card>
      </v-flex>
      <v-flex xs12 md9>
        <!-- NEW CARD -->
        <v-card class="ml-2 mr-2">

          <!-- top toolbar -->
          <v-row class="border-b--thin align-center pl-4 pr-2 pt-2 pb-2">

            <transition
            name="slide-x-reverse-transition"
            mode="out-in">

              <!-- ITEMS -->
              <div 
              v-if="selectedCount === 0"
              key="1"
              class="c-flex-r align-center subheading">

                <!-- select menu -->
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>mdi-check-box-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                    @click="selectPage">
                      <v-list-item-title>Select page</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-btn
                outlined
                class="mr-2"
                @click="newDefinition">
                  <v-icon>add</v-icon>
                  <div class="ml-1">
                    New definition
                  </div>
                </v-btn>

                <v-menu offset-y :close-on-content-click="false" min-width="280px">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      text
                      v-on="on"
                    >
                      <v-icon small>mdi-filter</v-icon>
                      <div class="ml-1">
                        Filter
                      </div>
                      <span v-if="activeFilterCount > 0">
                        &nbsp;|&nbsp;
                        <span class="color1--text">
                          {{ activeFilterCount }}
                        </span>
                      </span>
                      <v-icon small>mdi-menu-down</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="">
                    <v-layout justify-center align-center class="backgroundCard pa-2">
                      <v-btn outlined small @click="clearFilters">
                        Clear
                      </v-btn>
                      <v-spacer></v-spacer>
                      Filters
                      <v-spacer></v-spacer>
                      <v-btn color="color1" class="white--text" small>
                        Accept
                      </v-btn>
                    </v-layout>
                    <div class="c-hr"></div>
                    <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.customer = !filters.active.customer">
                      <v-icon small v-if="filters.active.customer" color="color1">
                        mdi-checkbox-marked-outline
                      </v-icon>
                      <v-icon small v-else>
                        mdi-checkbox-blank-outline
                      </v-icon>
                      &nbsp;
                      Customer:
                    </v-layout>
                    <div class="c-hr"></div>
                    <v-expand-transition>
                      <div v-show="filters.active.customer">
                        <div style="background: #f7fafc;" class="pt-1 pb-1">
                        </div>
                      </div>
                    </v-expand-transition>

                    <div class="c-hr"></div>
                    <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.date = !filters.active.date">
                      <v-icon small v-if="filters.active.date" color="color1">
                        mdi-checkbox-marked-outline
                      </v-icon>
                      <v-icon small v-else>
                        mdi-checkbox-blank-outline
                      </v-icon>
                      &nbsp;
                      Date:
                    </v-layout>
                    <div class="c-hr"></div>
                    <v-expand-transition>
                      <div v-show="filters.active.date">
                        <div style="background: #f7fafc;" class="pt-1 pb-1">
                          <v-select
                            v-model="filters.date.mainSelect"
                            class="ma-2 input-slot-thin-border caption"
                            :items="dateFilters"
                            dense
                            hide-details
                            solo
                          ></v-select>
                          <!-- DATE OPTIONS -->
                          <div v-if="filters.date.mainSelect === 'is in the last'">
                            <v-layout class="pl-2 pr-2" style="width: 12em;">
                                <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                                &nbsp;
                                <c-input :value.sync="filters.date.isInTheLast_input" class="crx-box-input mr-2" style="flex: 0 0 3em;"></c-input>
            
                                <v-select
                                  v-model="filters.date.isInTheLast_select"
                                  class="input-slot-thin-border caption"
                                  style="flex: 0 0 5em;"
                                  :items="['days', 'months']"
                                  dense
                                  hide-details
                                  solo
                                ></v-select>
                            
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is equal to'">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is between'">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                              and
                              <c-date :date.sync="filters.date.date2" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is after'" class="">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is on or after'" class="">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is before'" class="">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is on or before'" class="">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          
                        </div>
                      </div>
                    </v-expand-transition>
                    <!-- deleted -->
                    <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.deleted = !filters.active.deleted">
                      <v-icon small v-if="filters.active.deleted" color="color1">
                        mdi-checkbox-marked-outline
                      </v-icon>
                      <v-icon small v-else>
                        mdi-checkbox-blank-outline
                      </v-icon>
                      &nbsp;
                      Deleted:
                    </v-layout>
                    <div class="c-hr"></div>
                    <v-expand-transition>
                      <div v-show="filters.active.deleted">
                        <div class="pt-1 pb-1">
                          <v-row class="align-center pa-2">
                            <span class="label">
                              Showing deleted definitions
                            </span>
                          </v-row>
                        </div>
                      </div>
                    </v-expand-transition>
                    <!-- end deleted -->
                  </v-card>
                </v-menu>

              </div>

              <!-- selected count -->
              <div v-if="selectedCount > 0"
              key="2"
              class="c-flex-r align-center subheading">
                <v-btn
                icon
                class=""
                @click="selected = {}">
                  <v-icon color="color1">close</v-icon>
                </v-btn>
                <div class="text-sans font-weight-bold">
                  <span>&nbsp;{{ selectedCount }}</span>
                  selected 
                </div>
                <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
                <span class="icon--text ml-2">|</span>

                <!-- select menu -->
                <v-menu offset-y :close-on-content-click="false" min-width="300px">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>mdi-label</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-layout class="pa-2">
                      Label as
                    </v-layout>
                    <category-card :widgetMode="2" :onClick="assignLabel"></category-card>
                  </v-list>
                </v-menu>

                <v-btn 
                v-if="filters.active.deleted"
                icon
                @click="onRestore">
                  <v-icon>mdi-delete-restore</v-icon>
                </v-btn>
                <v-btn
                v-else
                icon
                @click="onDelete">
                  <v-icon>delete_outline</v-icon>
                </v-btn>
                <!-- select menu -->
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>mdi-check-box-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                    @click="selectPage">
                      <v-list-item-title>Select page</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    @click="selectNone">
                      <v-list-item-title>Select none</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>

            </transition>

            <v-spacer></v-spacer>

            <div>
              <transition
              name="fade-transition"
              mode="out-in">
                <v-layout v-if="isLoading" key="L1" class="mr-2" align-baseline>
                  <span class="grey--text caption">LOADING...</span>&nbsp;
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-layout>
                <div v-else key="L2"></div>
              </transition>
            </div>

            <inventory-categories class="ml-2"></inventory-categories>

          </v-row>
          <!-- !top toolbar -->

          <!-- temporary filters are active bar -->
          <v-row v-if="activeFilterCount > 0" class="pa-2 pl-4 backgroundCard align-center">
            <v-icon>mdi-alert</v-icon>&nbsp;
            Your results are currently filtered.
            <v-btn text @click="clearFilters" color="color1">
              Clear filters
            </v-btn>
          </v-row>
          <!-- temporary filters are active bar -->


          <table class="final-table th-no-padding full-width lines-b">
            <colgroup ref="colgroup1">
              <col width="30px">
              <col width="15px">
              <col width="15px">
              <col width="15px">
            </colgroup>

            <tr class="unselectable">

              <c-table-header
              title="Name"
              code="name"
              class="sticky"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>

              <c-table-header
              title="Stock"
              code="stock"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>

              <!--
              <th :class="[{'active-sort-column': filters.sortCol === 'stock'}]">
                <v-layout v-ripple @click="clickSortHeader('stock')" :class="['sort-button']" style="padding: 8px 12px 8px 16px;">
                  Stock
                  <v-icon 
                  small
                  color="color1"
                  :class="['sort-arrow', {'rotate': filters.sortCol === 'stock' && filters.sortAscending}, {'visible': filters.sortCol === 'stock' }]">
                    arrow_downward
                  </v-icon>
                </v-layout>
              </th>
              -->

              <c-table-header
              title="ID"
              code="id"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>

              <c-table-header
              title="Tags"
              code="tags"
              :filters="filters">
              </c-table-header>

            </tr>

            <tr>
              <td>
                <v-text-field
                v-model="filters.search.name"
                placeholder="Search..."
                hide-details
                class="crx-box-input"
                clearable
                color="color1"
                solo></v-text-field>
              </td>
              <td>
                
              </td>
              <td>
                <v-text-field
                v-model="filters.search.id"
                placeholder="Search..."
                hide-details
                class="crx-box-input"
                clearable
                color="color1"
                solo></v-text-field>
              </td>
              <td>

              </td>
            </tr>

          </table>

          <!-- top pagination toolbar -->
          <v-layout class="align-center">
            <div class="pa-4 label">
              {{ pagination.rowCount }} items
            </div>

            <v-spacer></v-spacer>

            <div class="mr-4">

              <v-tooltip top open-delay="300">
                <template v-slot:activator="{ on }">
                  <v-btn
                  v-on="on"
                  icon
                  small
                  color="color1"
                  :disabled="page <= 0"
                  @click="goToPreviousPage()"
                  class=""
                  >
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </template>
                <span>Previous page</span>
              </v-tooltip>

              <v-tooltip top open-delay="300">
                <template v-slot:activator="{ on }">
                  <v-btn
                  v-on="on"
                  icon
                  small
                  color="color1"
                  :disabled="page >= pagination.pages - 1"
                  @click="goToNextPage()"
                  class=""
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </template>
                <span>Next page</span>
              </v-tooltip>

            </div>
          </v-layout>
          <!-- !top pagination toolbar -->

          <table class="final-table lines-b pointer hover full-width">
            <colgroup ref="colgroup2">
              <col width="30px">
              <col width="15px">
              <col width="15px">
              <col width="15px">
            </colgroup>

            <list-row
            v-for="item in items" 
            :key="item.id"
            :item="item"
            :itemsMeta="itemsMeta"
            :selected="selected"
            :searchFilters="filters.search"
            @checkRow="checkRow(item)"
            @click.native="clickRow(item)"
            ></list-row>

          </table>

          <!-- BOTTOM TOOLBAR -->
          <v-layout align-center class="border-t--thin">
            <!-- PAGINATION -->
            <c-pagination
            :page="page"
            :pagination="pagination"
            :filters="filters"
            @updatePageNumber="updatePageNumber"
            @goToFirstPage="goToFirstPage"
            @goToPreviousPage="goToPreviousPage"
            @goToNextPage="goToNextPage"
            @goToLastPage="goToLastPage"
            ></c-pagination>
            <!-- PAGINATION -->
          </v-layout>
          <!-- !BOTTOM TOOLBAR -->
        </v-card>
        <!-- NEW CARD -->
      </v-flex>
    </v-layout>

    <expiring-soon class="ma-4"></expiring-soon>

  </div>
</template>

<script>
import axios from 'axios'
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListBindings'
import CTableHeader from '@/components/list-server/th'
import ListRow from './components/list-row'
import CSListItemsPerPage from '@/components/list-server/C-SListItemsPerPage'
import InventoryCategories from './components/categories/Main'
import CategoryCard from './components/categories/Card'
import ExpiringSoon from '@/components/v/inventory/expiring-soon/Card'

export default {
  name: 'InventoryDefinitionsPage',
  components: {
    ListRow,
    CSListItemsPerPage,
    InventoryCategories,
    CategoryCard,
    CTableHeader,
    ExpiringSoon
  },
  mixins: [ServerListController, ServerListBindings],
  data () {
    return {
      page: 0,
      filters: {
        rowsPerPage: 5,
        sortCol: 'name',
        sortAscending: true,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          sku: '',
          id: '',
          name: ''
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        categories: []
      },
      dateFilters: ['is in the last', 'is equal to', 'is between', 'is after', 'is on or after', 'is before', 'is on or before'],
      itemsMeta: {
        newID: null // this will be set to the newst created row
      },
      isLoading: false
    }
  },
  methods: {
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        this.$router.push('/inventory/inventory-definition/view/' + item.id)
      }
    },
    newDefinition () {
      this.$router.push('/inventory/inventory-definitions/new')
    },
    onDelete () {
      var idArray = this.getSelectedRows()
      var title = 'Delete ' + idArray.length + ' definition' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$axios.post('inventory-definitions/delete', idArray,
            {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(response => {
              this.selected = {} // This MUST be done after a successfull delete
              this.loadAPI()
            })
            .catch(error => this.$root.$errorSnackbar(error))
        }
      })
    },
    onRestore () {
      var idArray = this.getSelectedRows()
      var title = 'Restore ' + idArray.length + ' definition' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$axios.post('inventory-definitions/restore', idArray,
            {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(response => {
              this.selected = {} // This MUST be done after a successfull delete
              this.loadAPI()
            })
            .catch(error => this.$root.$errorSnackbar(error))
        }
      })
    },
    assignLabel (item) {
      var selectedRows = this.getSelectedRows()
      var data = selectedRows.map(id => {
        return {
          item_id: id,
          category_id: item.id,
          category: 0
        }
      })
      console.log(data)
      return new Promise((resolve, reject) => {
        this.$axios.post('categories/bulk-assign',
          data,
          {headers: {'Content-Type': 'application/json'}})
          .then(response => {
            // this.loadAPI()
            alert('Success')
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    },
    debounceLoad: _.debounce(function (e) {
      // this.pushFiltersToRoute()
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        axios.all([
          this.$axios.get(`/inventory/grouped?filters=${encodedFilters}&page=${this.page}`)
        ])
        .then(axios.spread((response) => {
          var hrend = response.data.execution_time
          console.log(hrend)
          console.info('Execution time (hr): %ds %dms', hrend[0], hrend[1] / 1000000)
          var rows = response.data.rows
          this.pagination.rowCount = response.data.count
          this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
          this.items = rows
        }))
        .then(() => resolve())
        .catch(error => {
          console.log(error)
          this.$root.$errorSnackbar(error)
          reject(error)
        })
        .then(() => {
          this.isLoading = false
        })
      })
    }, 150, {leading: true}),
    loadAPI () {
      return this.debounceLoad()
    }
  },
  created () {
    /* this.page = Number(this.$route.query.page) || 0
    var filters = JSON.parse(JSON.stringify(this.filters))
    this.rightSideMerge(filters, this.decodedUrl)
    this.setFiltersWithoutTriggeringWatcher(filters) */
    this.loadAPI()
  },
  activated () {
    // this triggers when a keep alive component is returned to
    this.loadAPI()
  }
}
</script>

